// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"451d33f6","455":"c2269a7a","977":"9752bec8"}[chunkId] + ".chunk.js";
};